
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"5","r":"2"}}),_c('circle',{attrs:{"cx":"19","cy":"5","r":"2"}}),_c('circle',{attrs:{"cx":"5","cy":"5","r":"2"}}),_c('circle',{attrs:{"cx":"12","cy":"19","r":"2"}}),_c('circle',{attrs:{"cx":"19","cy":"19","r":"2"}}),_c('circle',{attrs:{"cx":"5","cy":"19","r":"2"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"2"}}),_c('circle',{attrs:{"cx":"19","cy":"12","r":"2"}}),_c('circle',{attrs:{"cx":"5","cy":"12","r":"2"}})])
          )
        }
      }
    